export const common = {
  system_name: "Guangdong International Cultural Exchange Center",
  time_full: `{m} {d}, {y}`,
  search: 'Search',
  back: 'Back',
  see_more: 'See More',
  search_empty: 'Sorry, no search results',
  content_empty: 'No more content yet',
  week: {
    w0: 'Sunday',
    w1: 'Monday',
    w2: 'Tuesday',
    w3: 'Wednesday',
    w4: 'Thursday',
    w5: 'Friday',
    w6: 'Saturday',
  },
  month: {
    m1: 'January',
    m2: 'February',
    m3: 'March',
    m4: 'April',
    m5: 'May',
    m6: 'June',
    m7: 'July',
    m8: 'August',
    m9: 'September',
    m10: 'October',
    m11: 'November',
    m22: 'December',
  },
}
// 菜单
export const menu = {
  home: 'Home',
  intro: 'Intro',
  brief: 'Brief',
  organization: 'Org Struct',
  rule: 'Rule',

  news: 'News',
  moments: 'Moments',
  exchange: 'Exchange',
  council: 'Council',
  council_intro: 'Council Intro',
  council_demeanour: 'Council Style',
  council_composition: 'Council Works',

  rostrum: 'Rostrum',
  search: 'Search',
}
// 职称
export const staff = {
  honorary_chairman: 'Honorary Chairman',
  chairman: 'Chairman',
  vice_chairman: 'Vice Chairman',
  counselor: 'Counselor',
  honorary_vice_chairman: 'Honorary Vice Chairman',
  council: 'Council',
  history_council: 'History Council',
  secretary_general: 'Secretary General',
}
// 底部
export const footer = {
  link: 'Link',
  address: 'Address',
  phone: 'Tel',
  email: 'Email',
}

// 文章
export const art = {
  time: 'Time',
  author: 'Author',
  source: 'Source',
}
